/* eslint-disable no-cond-assign */
import { getCountryName } from '../../../../utils/i18n';

import { ProposalDAOInterface } from '../ProposalDAO';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import { ProposalFieldDAO } from '../ProposalFieldDAO';
import { ComparisonItemDAO } from '../ProposalItemDAO';
import { DataPoints, DataPointResponse } from '../DataPoints';
import { HoldingCell, NotApplicableCell, PercentageCell } from '../../../../views/components/cells/index';
import { ProposalStyleClassNames } from '../../ProposalStyleClassNames';
import DonutData from '@/types/donut-data';
import AllocationDetails from '@/types/allocation-details';

/**
 * @class CountryAllocationDAO Data Access Object
 */
export default class CountryAllocationDAO extends ComparisonItemBasedProposalDAO {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new CountryAllocationDAO(proposal, proposalElement);
  }

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return ['DEFAULT'];
  }

  protected build(): void {
    const { locale } = this.proposal.options;
    let filterCount: number = 10;
    let extraColumn: boolean = false;
    let start: number = 1;

    // test for options
    const daoConfig: ProposalNS.CountryAllocationConfig = this.proposalElement.DAO as ProposalNS.CountryAllocationConfig;
    if (daoConfig.filterTopXDAOOptions !== undefined) {
      filterCount = daoConfig.filterTopXDAOOptions.count;

      if (daoConfig.filterTopXDAOOptions.start) {
        start = daoConfig.filterTopXDAOOptions.start;
      }
    }

    if (daoConfig.extraColumnsDAOOptions !== undefined && daoConfig.extraColumnsDAOOptions.columns.indexOf('COUNTRY_NAME') !== -1) {
      extraColumn = true;
    }

    if (this.customFieldNames != null) {
      for (const name of this.customFieldNames.names) {
        this.addFieldName(this.formatLocalizedString(name), ProposalStyleClassNames.ProposalTableContent);
      }
    }

    let itemDAO = null;
    while ((itemDAO = this.nextItem()) !== null) {
      const cas: DataPointResponse<AllocationDetails[]> = DataPoints.getCountryAllocations(itemDAO.item);
      this.addDisclaimerKeys(cas.disclaimerKeys, itemDAO.item);

      for (let i = start; i < start + filterCount; i++) {
        const ca = cas.response[i - 1];

        if (ca !== undefined) {
          if (extraColumn) {
            this.addItemField(itemDAO, ca.name, { weight: ca.weight, name: getCountryName(ca.name, locale) }, HoldingCell);
          } else {
            this.addItemField(itemDAO, getCountryName(ca.name, locale), ca.weight, PercentageCell);
          }

          if (this.customFieldNames === null) {
            this.addFieldName(getCountryName(ca.name, locale), ProposalStyleClassNames.ProposalTableContent);
          }
        } else {
          this.addItemField(itemDAO, '', {}, NotApplicableCell);

          if (this.customFieldNames === null) {
            this.addFieldName('', ProposalStyleClassNames.ProposalTableContent);
          }
        }
      }
    }
  }

  getDonutData(index: number = 0): DonutData | null {
    const out: DonutData | null = super.getDonutData(index);

    if (out && this.colorsDict) {
      out.colorsDict = this.colorsDict;
    }
    return out;
  }

  // private methods

  private addItemField(itemDAO: ComparisonItemDAO, name: string, value: any, celltype: any): number {
    const field: ProposalFieldDAO = new ProposalFieldDAO(name, value, ProposalStyleClassNames.ProposalTableContent);
    field.cellType = celltype;
    this.addFieldDAO(itemDAO, field);
    return value;
  }
}
